function toggleNav() {
  var body = document.body;
  var hamburger = document.getElementById('js-hamburger');
  var blackBg = document.getElementById('js-black-bg');

  hamburger.addEventListener('click', function() {
    body.classList.toggle('nav-open');
  });
  blackBg.addEventListener('click', function() {
    body.classList.remove('nav-open');
  });
}
toggleNav();



$(function(){
  $('a[href^="#"]').click(function() {
    var adjust = 0;
    var speed = 1200;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


$('.mv_slider').slick({
  autoplay: true,
  fade: true,
});

$('.detailSlider').slick({
  autoplay: true,
  arrows: true,
  dots: true,
  prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0884/6331/1149/files/d_slick_prev.png" class="slide-arrow prev-arrow">',
  nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0884/6331/1149/files/d_slick_next.png" class="slide-arrow next-arrow">'
});



$(function () {
    // aimation呼び出し
    if ($('.js-scroll-trigger').length) {
        scrollAnimation();
    }

    // aimation関数
    function scrollAnimation() {
        $(window).scroll(function () {
            $(".js-scroll-trigger").each(function () {
                let position = $(this).offset().top,
                    scroll = $(window).scrollTop(),
                    windowHeight = $(window).height();

                if (scroll > position - windowHeight + 300) {
                    $(this).addClass('is-active');
                }
            });
        });
    }
    $(window).trigger('scroll');
});




$('.color_acc_title').on('click', function() {
    $(this).toggleClass('active');
    $(this).next('.color_acc_contents').slideToggle();
});

$(function(){
// color アコーディオン1押下処理
$('.acc01_colors li').click(function() {
  $('.acc01_colors li').removeClass('active');
  $(this).addClass('active');
  setTimeout(function(){ 
    $('.color_acc02 .color_acc_contents').slideToggle();
    $('.color_acc02 .color_acc_title').addClass('active');
    $("html,body").animate({scrollTop:$('#color_acc02').offset().top},500);
  },200);
  var code=  $(this).data('code');
  var click=  $(this).data('id');
  var color =  $(this).data('color');
  $('.select01').addClass(code);
  $('#select01-1').text(click);
  $('#select01-2').text(color);
});
// color アコーディオン2押下処理
$('.acc02_colors li').click(function() {
  $('.acc02_colors li').removeClass('active');
  $(this).addClass('active');
  setTimeout(function(){ 
    $('.color_acc03 .color_acc_contents').slideToggle();
    $('.color_acc03 .color_acc_title').addClass('active');
    $("html,body").animate({scrollTop:$('#color_acc03').offset().top},500);
  },200);
  var code=  $(this).data('code');
  var click=  $(this).data('id');
  var color =  $(this).data('color');
  $('.select02').addClass(code);
  $('#select02-1').text(click);
  $('#select02-2').text(color);
});
// color アコーディオン3押下処理
$('.acc03_colors li').click(function() {
  $('.acc03_colors li').removeClass('active');
  $(this).addClass('active');
  setTimeout(function(){ 
    $('.color_acc04 .color_acc_contents').slideToggle();
    $('.color_acc04 .color_acc_title').addClass('active');
    $("html,body").animate({scrollTop:$('#color_acc04').offset().top},500);
  },200);
  var code=  $(this).data('code');
  var click=  $(this).data('id');
  var color =  $(this).data('color');
  $('.select03').addClass(code);
  $('#select03-1').text(click);
  $('#select03-2').text(color);
});
// color アコーディオン4押下処理
$('.acc04_colors li').click(function() {
  $('.acc04_colors li').removeClass('active');
  $(this).addClass('active');
  setTimeout(function(){ 
    $('.color_kansei').addClass('apper');
    $("html,body").animate({scrollTop:$('#color_acc05').offset().top},500);
  },200);
  var code=  $(this).data('code');
  var click=  $(this).data('id');
  var color =  $(this).data('color');
  $('.select04').addClass(code);
  $('#select04-1').text(click);
  $('#select04-2').text(color);
});
  
  
  
$(function(){
  function sliderSetting(){
    var width = $(window).width();
    if(width <= 850){
      $('.rank_img').not('.slick-initialized').slick({
        autoplay: false,
        centerMode: false,
        arrows:true,
        infinite: true,
        dots:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '0px',
      });
    } else {
      $('.rank_img.slick-initialized').slick('unslick');
    }
  }
  sliderSetting();
  $(window).on('resize', function () {
    sliderSetting();
  });
});

});


$(function(){
  // カート周り
  $('.c-selectArea01 li').click(function() {
    $('.c-selectArea01 li').removeClass('active');
    $(this).addClass('active');
  });
  $('.c-selectArea02 li').click(function() {
    $('.c-selectArea02 li').removeClass('active');
    $(this).addClass('active');
  });
  $('.c-selectArea03 li').click(function() {
    $('.c-selectArea03 li').removeClass('active');
    $(this).addClass('active');
  });
  $('.c-selectArea04 li').click(function() {
    $('.c-selectArea04 li').removeClass('active');
    $(this).addClass('active');
  });
});


$('.q_title').on('click', function() {
    $(this).toggleClass('active');
    $(this).next('.a_contents').slideToggle();
});